import { SubtitleSection } from "chq";

export const sectionModifications = (section: SubtitleSection, timeAdjustment: number) => {
  if (section.creatomateId) {
    return {
      [`${section.creatomateId}.time`]: Math.max(section.startTime + timeAdjustment, 0)
    };
  }

  return {};
};

const updatedSection = (section: SubtitleSection, timeAdjustment: number) => ({
  ...section,
  startTime: section.startTime + timeAdjustment,
  endTime: section.endTime + timeAdjustment
});

export default updatedSection;
